import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { ApplicationForChecklist } from "../types";
import { calculateApplicationCheckList } from "../lib/calculateApplicationCheckList";

export const useApplicationCheckList = (
  application: ApplicationForChecklist
) => {
  const [applicationCheckList, loadingApplication, errorApplication] =
    useDocumentData(doc(db, "applications_progressTracker", application.id));
  const [sailorCheckList, loadingSailor, errorSailor] = useDocumentData(
    application.applicant?.sailor &&
      doc(db, "sailors_progressTracker", application.applicant?.sailor?.id)
  );
  const [jointApplicantCheckList, loadingJoint, errorJoint] = useDocumentData(
    application.jointApplicant?.sailor &&
      doc(db, "sailors_progressTracker", application.jointApplicant?.sailor?.id)
  );
  const [jointApplicantRiskProfile, loadingJointRisk, errorJointRisk] =
    useDocumentData(
      application.jointApplicant?.sailor &&
        doc(db, "sailorRiskProfiles", application.jointApplicant?.sailor?.id)
    );
  const [applicantRiskProfile, loadingRisk, errorRisk] = useDocumentData(
    application.applicant?.sailor &&
      doc(db, "sailorRiskProfiles", application.applicant?.sailor?.id)
  );
  const [affordabilityReport, loadingAffordability, errorAffordability] =
    useDocumentData(
      doc(db, "applications", application.id, "affordabilityReport", "current")
    );

  const loading =
    loadingApplication ||
    loadingAffordability ||
    loadingSailor ||
    loadingJoint ||
    loadingJointRisk ||
    loadingRisk;
  const error =
    errorApplication ||
    errorAffordability ||
    errorSailor ||
    errorJoint ||
    errorJointRisk ||
    errorRisk;
  const checklist = loading
    ? undefined
    : calculateApplicationCheckList(
        application,
        applicationCheckList,
        sailorCheckList,
        jointApplicantCheckList,
        applicantRiskProfile,
        jointApplicantRiskProfile,
        affordabilityReport
      );

  return {
    loading,
    error,
    checklist,
  };
};
